/**
 * WelcomeDialog - No longer needed with new guided tutorial
 * Tutorial now starts directly with spotlight-based Coachmarks
 */

export const WelcomeDialog = () => {
  // Deprecated - tutorial now uses direct Coachmark flow
  return null;
};
